import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Slider from 'react-slick';
import { BREAKPOINTS } from 'screens/Collection';
import { isDesktopBreakpoint, isLargeDesktopBreakpoint } from 'helpers/BreakpointHelper';
import times from 'helpers/utils';
import Style from './LoaderCarousel.module.scss';

const useTransform = true;
const useCSS = true;

const LoaderCarousel = props => {
  const { breakpoint, isPoster } = props;
  const { carouselLimit } = BREAKPOINTS[breakpoint];
  const settings = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: carouselLimit,
    useTransform,
    useCSS,
  };
  const isPosterAndDesktopBreakpoint = isDesktopBreakpoint(breakpoint) && isPoster;

  const LoaderPosterBG = i => (
    <div key={i}>
      <div className={classNames([Style.slidePosterBackground, Style.isNation])} />
      <div className={Style.posterTitlePlaceholder} />
    </div>
  );
  const LoaderTileBG = i => (
    <div key={i}>
      <div className={classNames([Style.slideBackground, Style.isNation])} />
      <div className={Style.tileTitlePlaceholder} />
      <div className={Style.tileDescriptionPlaceholder} />
    </div>
  );
  const LoadingTileCount = isLargeDesktopBreakpoint(breakpoint) ? 5 : 4;

  return (
    <>
      <div className={Style.headerPlaceholderBackground} />
      <Slider {...settings} trayProps={{ role: 'listbox' }}>
        {isPosterAndDesktopBreakpoint
          ? times(LoadingTileCount, LoaderPosterBG)
          : times(LoadingTileCount, LoaderTileBG)}
      </Slider>
    </>
  );
};

LoaderCarousel.defaultProps = {
  isPoster: false,
};

LoaderCarousel.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  isPoster: PropTypes.bool,
};

export default React.memo(LoaderCarousel);
